import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
import { Primary as DSPrimary } from "@cinch-labs/design-system";
import cx from "classnames";
import styles from "./primary.module.css";
export var Primary = function(_param) /*#__PURE__*/ {
    var className = _param.className, children = _param.children, rest = _object_without_properties(_param, [
        "className",
        "children"
    ]);
    return _jsx(DSPrimary, _object_spread_props(_object_spread({
        classNames: {
            button: cx(styles.root, className)
        }
    }, rest), {
        children: children
    }));
};
